function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
 * Splide.js
 * Version  : 3.3.1
 * License  : MIT
 * Copyright: 2021 Naotoshi Fujita
 */
var PROJECT_CODE = "splide";
var DATA_ATTRIBUTE = "data-".concat(PROJECT_CODE);
var CREATED = 1;
var MOUNTED = 2;
var IDLE = 3;
var MOVING = 4;
var DESTROYED = 5;
var STATES = {
  CREATED: CREATED,
  MOUNTED: MOUNTED,
  IDLE: IDLE,
  MOVING: MOVING,
  DESTROYED: DESTROYED
};
var DEFAULT_EVENT_PRIORITY = 10;
var DEFAULT_USER_EVENT_PRIORITY = 20;

function empty(array) {
  array.length = 0;
}

function isObject(subject) {
  return !isNull(subject) && _typeof(subject) === "object";
}

function isArray(subject) {
  return Array.isArray(subject);
}

function isFunction(subject) {
  return typeof subject === "function";
}

function isString(subject) {
  return typeof subject === "string";
}

function isUndefined(subject) {
  return typeof subject === "undefined";
}

function isNull(subject) {
  return subject === null;
}

function isHTMLElement(subject) {
  return subject instanceof HTMLElement;
}

function toArray(value) {
  return isArray(value) ? value : [value];
}

function forEach(values, iteratee) {
  toArray(values).forEach(iteratee);
}

function includes(array, value) {
  return array.indexOf(value) > -1;
}

function push(array, items) {
  array.push.apply(array, _toConsumableArray(toArray(items)));
  return array;
}

var arrayProto = Array.prototype;

function slice(arrayLike, start, end) {
  return arrayProto.slice.call(arrayLike, start, end);
}

function find(arrayLike, predicate) {
  return slice(arrayLike).filter(predicate)[0];
}

function toggleClass(elm, classes, add) {
  if (elm) {
    forEach(classes, function (name) {
      if (name) {
        elm.classList[add ? "add" : "remove"](name);
      }
    });
  }
}

function addClass(elm, classes) {
  toggleClass(elm, isString(classes) ? classes.split(" ") : classes, true);
}

function append(parent, children) {
  forEach(children, parent.appendChild.bind(parent));
}

function before(nodes, ref) {
  forEach(nodes, function (node) {
    var parent = ref.parentNode;

    if (parent) {
      parent.insertBefore(node, ref);
    }
  });
}

function matches(elm, selector) {
  return (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}

function children(parent, selector) {
  return parent ? slice(parent.children).filter(function (child) {
    return matches(child, selector);
  }) : [];
}

function child(parent, selector) {
  return selector ? children(parent, selector)[0] : parent.firstElementChild;
}

function forOwn(object, iteratee, right) {
  if (object) {
    var keys = Object.keys(object);
    keys = right ? keys.reverse() : keys;

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];

      if (key !== "__proto__") {
        if (iteratee(object[key], key) === false) {
          break;
        }
      }
    }
  }

  return object;
}

function assign(object) {
  slice(arguments, 1).forEach(function (source) {
    forOwn(source, function (value, key) {
      object[key] = source[key];
    });
  });
  return object;
}

function merge(object, source) {
  forOwn(source, function (value, key) {
    if (isArray(value)) {
      object[key] = value.slice();
    } else if (isObject(value)) {
      object[key] = merge(isObject(object[key]) ? object[key] : {}, value);
    } else {
      object[key] = value;
    }
  });
  return object;
}

function removeAttribute(elm, attrs) {
  if (elm) {
    forEach(attrs, function (attr) {
      elm.removeAttribute(attr);
    });
  }
}

function setAttribute(elm, attrs, value) {
  if (isObject(attrs)) {
    forOwn(attrs, function (value2, name) {
      setAttribute(elm, name, value2);
    });
  } else {
    isNull(value) ? removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
  }
}

function create(tag, attrs, parent) {
  var elm = document.createElement(tag);

  if (attrs) {
    isString(attrs) ? addClass(elm, attrs) : setAttribute(elm, attrs);
  }

  parent && append(parent, elm);
  return elm;
}

function style(elm, prop, value) {
  if (isUndefined(value)) {
    return getComputedStyle(elm)[prop];
  }

  if (!isNull(value)) {
    var style2 = elm.style;
    value = "".concat(value);

    if (style2[prop] !== value) {
      style2[prop] = value;
    }
  }
}

function display(elm, display2) {
  style(elm, "display", display2);
}

function focus(elm) {
  elm["setActive"] && elm["setActive"]() || elm.focus({
    preventScroll: true
  });
}

function getAttribute(elm, attr) {
  return elm.getAttribute(attr);
}

function hasClass(elm, className) {
  return elm && elm.classList.contains(className);
}

function rect(target) {
  return target.getBoundingClientRect();
}

function remove(nodes) {
  forEach(nodes, function (node) {
    if (node && node.parentNode) {
      node.parentNode.removeChild(node);
    }
  });
}

function measure(parent, value) {
  if (isString(value)) {
    var div = create("div", {
      style: "width: ".concat(value, "; position: absolute;")
    }, parent);
    value = rect(div).width;
    remove(div);
  }

  return value;
}

function parseHtml(html) {
  return child(new DOMParser().parseFromString(html, "text/html").body);
}

function prevent(e, stopPropagation) {
  e.preventDefault();

  if (stopPropagation) {
    e.stopPropagation();
    e.stopImmediatePropagation();
  }
}

function query(parent, selector) {
  return parent && parent.querySelector(selector);
}

function queryAll(parent, selector) {
  return slice(parent.querySelectorAll(selector));
}

function removeClass(elm, classes) {
  toggleClass(elm, classes, false);
}

function unit(value) {
  return isString(value) ? value : value ? "".concat(value, "px") : "";
}

function assert(condition) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

  if (!condition) {
    throw new Error("[".concat(PROJECT_CODE, "] ").concat(message));
  }
}

function nextTick(callback) {
  setTimeout(callback);
}

var noop = function noop() {};

function raf(func) {
  return requestAnimationFrame(func);
}

var min = Math.min,
    max = Math.max,
    floor = Math.floor,
    ceil = Math.ceil,
    abs = Math.abs;

function approximatelyEqual(x, y, epsilon) {
  return abs(x - y) < epsilon;
}

function between(number, minOrMax, maxOrMin, exclusive) {
  var minimum = min(minOrMax, maxOrMin);
  var maximum = max(minOrMax, maxOrMin);
  return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
}

function clamp(number, x, y) {
  var minimum = min(x, y);
  var maximum = max(x, y);
  return min(max(minimum, number), maximum);
}

function sign(x) {
  return +(x > 0) - +(x < 0);
}

function camelToKebab(string) {
  return string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}

function format(string, replacements) {
  forEach(replacements, function (replacement) {
    string = string.replace("%s", "".concat(replacement));
  });
  return string;
}

function pad(number) {
  return number < 10 ? "0".concat(number) : "".concat(number);
}

var ids = {};

function uniqueId(prefix) {
  return "".concat(prefix).concat(pad(ids[prefix] = (ids[prefix] || 0) + 1));
}

function EventBus() {
  var handlers = {};

  function on(events, callback, key) {
    var priority = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_EVENT_PRIORITY;
    forEachEvent(events, function (event, namespace) {
      handlers[event] = handlers[event] || [];
      push(handlers[event], {
        _event: event,
        _callback: callback,
        _namespace: namespace,
        _priority: priority,
        _key: key
      }).sort(function (handler1, handler2) {
        return handler1._priority - handler2._priority;
      });
    });
  }

  function off(events, key) {
    forEachEvent(events, function (event, namespace) {
      var eventHandlers = handlers[event];
      handlers[event] = eventHandlers && eventHandlers.filter(function (handler) {
        return handler._key ? handler._key !== key : key || handler._namespace !== namespace;
      });
    });
  }

  function offBy(key) {
    forOwn(handlers, function (eventHandlers, event) {
      off(event, key);
    });
  }

  function emit(event) {
    var _arguments = arguments;
    (handlers[event] || []).forEach(function (handler) {
      handler._callback.apply(handler, slice(_arguments, 1));
    });
  }

  function destroy() {
    handlers = {};
  }

  function forEachEvent(events, iteratee) {
    toArray(events).join(" ").split(" ").forEach(function (eventNS) {
      var fragments = eventNS.split(".");
      iteratee(fragments[0], fragments[1]);
    });
  }

  return {
    on: on,
    off: off,
    offBy: offBy,
    emit: emit,
    destroy: destroy
  };
}

var EVENT_MOUNTED = "mounted";
var EVENT_READY = "ready";
var EVENT_MOVE = "move";
var EVENT_MOVED = "moved";
var EVENT_CLICK = "click";
var EVENT_ACTIVE = "active";
var EVENT_INACTIVE = "inactive";
var EVENT_VISIBLE = "visible";
var EVENT_HIDDEN = "hidden";
var EVENT_SLIDE_KEYDOWN = "slide:keydown";
var EVENT_REFRESH = "refresh";
var EVENT_UPDATED = "updated";
var EVENT_RESIZE = "resize";
var EVENT_RESIZED = "resized";
var EVENT_REPOSITIONED = "repositioned";
var EVENT_DRAG = "drag";
var EVENT_DRAGGING = "dragging";
var EVENT_DRAGGED = "dragged";
var EVENT_SCROLL = "scroll";
var EVENT_SCROLLED = "scrolled";
var EVENT_DESTROY = "destroy";
var EVENT_ARROWS_MOUNTED = "arrows:mounted";
var EVENT_ARROWS_UPDATED = "arrows:updated";
var EVENT_PAGINATION_MOUNTED = "pagination:mounted";
var EVENT_PAGINATION_UPDATED = "pagination:updated";
var EVENT_NAVIGATION_MOUNTED = "navigation:mounted";
var EVENT_AUTOPLAY_PLAY = "autoplay:play";
var EVENT_AUTOPLAY_PLAYING = "autoplay:playing";
var EVENT_AUTOPLAY_PAUSE = "autoplay:pause";
var EVENT_LAZYLOAD_LOADED = "lazyload:loaded";

function EventInterface(Splide2) {
  var event = Splide2.event;
  var key = {};
  var listeners = [];

  function on(events, callback, priority) {
    event.on(events, callback, key, priority);
  }

  function off(events) {
    event.off(events, key);
  }

  function bind(targets, events, callback, options) {
    forEachEvent(targets, events, function (target, event2) {
      listeners.push([target, event2, callback, options]);
      target.addEventListener(event2, callback, options);
    });
  }

  function unbind(targets, events, callback) {
    forEachEvent(targets, events, function (target, event2) {
      listeners = listeners.filter(function (listener) {
        if (listener[0] === target && listener[1] === event2 && (!callback || listener[2] === callback)) {
          target.removeEventListener(event2, listener[2], listener[3]);
          return false;
        }

        return true;
      });
    });
  }

  function forEachEvent(targets, events, iteratee) {
    forEach(targets, function (target) {
      if (target) {
        events.split(" ").forEach(iteratee.bind(null, target));
      }
    });
  }

  function destroy() {
    listeners = listeners.filter(function (data) {
      return unbind(data[0], data[1]);
    });
    event.offBy(key);
  }

  event.on(EVENT_DESTROY, destroy, key);
  return {
    on: on,
    off: off,
    emit: event.emit,
    bind: bind,
    unbind: unbind,
    destroy: destroy
  };
}

function RequestInterval(interval, onInterval, onUpdate, limit) {
  var now = Date.now;
  var startTime;
  var rate = 0;
  var id;
  var paused = true;
  var count = 0;

  function update() {
    if (!paused) {
      var elapsed = now() - startTime;

      if (elapsed >= interval) {
        rate = 1;
        startTime = now();
      } else {
        rate = elapsed / interval;
      }

      if (onUpdate) {
        onUpdate(rate);
      }

      if (rate === 1) {
        onInterval();

        if (limit && ++count >= limit) {
          return pause();
        }
      }

      raf(update);
    }
  }

  function start(resume) {
    !resume && cancel();
    startTime = now() - (resume ? rate * interval : 0);
    paused = false;
    raf(update);
  }

  function pause() {
    paused = true;
  }

  function rewind() {
    startTime = now();
    rate = 0;

    if (onUpdate) {
      onUpdate(rate);
    }
  }

  function cancel() {
    cancelAnimationFrame(id);
    rate = 0;
    id = 0;
    paused = true;
  }

  function isPaused() {
    return paused;
  }

  return {
    start: start,
    rewind: rewind,
    pause: pause,
    cancel: cancel,
    isPaused: isPaused
  };
}

function State(initialState) {
  var state = initialState;

  function set(value) {
    state = value;
  }

  function is(states) {
    return includes(toArray(states), state);
  }

  return {
    set: set,
    is: is
  };
}

function Throttle(func, duration) {
  var interval;

  function throttled() {
    var _arguments2 = arguments,
        _this = this;

    if (!interval) {
      interval = RequestInterval(duration || 0, function () {
        func.apply(_this, _arguments2);
        interval = null;
      }, null, 1);
      interval.start();
    }
  }

  return throttled;
}

function Options(Splide2, Components2, options) {
  var throttledObserve = Throttle(observe);
  var initialOptions;
  var points;
  var currPoint;

  function setup() {
    try {
      merge(options, JSON.parse(getAttribute(Splide2.root, DATA_ATTRIBUTE)));
    } catch (e) {
      assert(false, e.message);
    }

    initialOptions = merge({}, options);
    var breakpoints = options.breakpoints;

    if (breakpoints) {
      var isMin = options.mediaQuery === "min";
      points = Object.keys(breakpoints).sort(function (n, m) {
        return isMin ? +m - +n : +n - +m;
      }).map(function (point) {
        return [point, matchMedia("(".concat(isMin ? "min" : "max", "-width:").concat(point, "px)"))];
      });
      observe();
    }
  }

  function mount() {
    if (points) {
      addEventListener("resize", throttledObserve);
    }
  }

  function destroy(completely) {
    if (completely) {
      removeEventListener("resize", throttledObserve);
    }
  }

  function observe() {
    var item = find(points, function (item2) {
      return item2[1].matches;
    }) || [];

    if (item[0] !== currPoint) {
      onMatch(currPoint = item[0]);
    }
  }

  function onMatch(point) {
    var newOptions = options.breakpoints[point] || initialOptions;

    if (newOptions.destroy) {
      Splide2.options = initialOptions;
      Splide2.destroy(newOptions.destroy === "completely");
    } else {
      if (Splide2.state.is(DESTROYED)) {
        destroy(true);
        Splide2.mount();
      }

      Splide2.options = newOptions;
    }
  }

  return {
    setup: setup,
    mount: mount,
    destroy: destroy
  };
}

var RTL = "rtl";
var TTB = "ttb";
var ORIENTATION_MAP = {
  marginRight: ["marginBottom", "marginLeft"],
  autoWidth: ["autoHeight"],
  fixedWidth: ["fixedHeight"],
  paddingLeft: ["paddingTop", "paddingRight"],
  paddingRight: ["paddingBottom", "paddingLeft"],
  width: ["height"],
  left: ["top", "right"],
  right: ["bottom", "left"],
  x: ["y"],
  X: ["Y"],
  Y: ["X"],
  ArrowLeft: ["ArrowUp", "ArrowRight"],
  ArrowRight: ["ArrowDown", "ArrowLeft"]
};

function Direction(Splide2, Components2, options) {
  function resolve(prop, axisOnly) {
    var direction = options.direction;
    var index = direction === RTL && !axisOnly ? 1 : direction === TTB ? 0 : -1;
    return ORIENTATION_MAP[prop][index] || prop;
  }

  function orient(value) {
    return value * (options.direction === RTL ? 1 : -1);
  }

  return {
    resolve: resolve,
    orient: orient
  };
}

var CLASS_ROOT = PROJECT_CODE;
var CLASS_SLIDER = "".concat(PROJECT_CODE, "__slider");
var CLASS_TRACK = "".concat(PROJECT_CODE, "__track");
var CLASS_LIST = "".concat(PROJECT_CODE, "__list");
var CLASS_SLIDE = "".concat(PROJECT_CODE, "__slide");
var CLASS_CLONE = "".concat(CLASS_SLIDE, "--clone");
var CLASS_CONTAINER = "".concat(CLASS_SLIDE, "__container");
var CLASS_ARROWS = "".concat(PROJECT_CODE, "__arrows");
var CLASS_ARROW = "".concat(PROJECT_CODE, "__arrow");
var CLASS_ARROW_PREV = "".concat(CLASS_ARROW, "--prev");
var CLASS_ARROW_NEXT = "".concat(CLASS_ARROW, "--next");
var CLASS_PAGINATION = "".concat(PROJECT_CODE, "__pagination");
var CLASS_PAGINATION_PAGE = "".concat(CLASS_PAGINATION, "__page");
var CLASS_PROGRESS = "".concat(PROJECT_CODE, "__progress");
var CLASS_PROGRESS_BAR = "".concat(CLASS_PROGRESS, "__bar");
var CLASS_AUTOPLAY = "".concat(PROJECT_CODE, "__autoplay");
var CLASS_PLAY = "".concat(PROJECT_CODE, "__play");
var CLASS_PAUSE = "".concat(PROJECT_CODE, "__pause");
var CLASS_SPINNER = "".concat(PROJECT_CODE, "__spinner");
var CLASS_INITIALIZED = "is-initialized";
var CLASS_ACTIVE = "is-active";
var CLASS_PREV = "is-prev";
var CLASS_NEXT = "is-next";
var CLASS_VISIBLE = "is-visible";
var CLASS_LOADING = "is-loading";
var STATUS_CLASSES = [CLASS_ACTIVE, CLASS_VISIBLE, CLASS_PREV, CLASS_NEXT, CLASS_LOADING];
var CLASSES = {
  slide: CLASS_SLIDE,
  clone: CLASS_CLONE,
  arrows: CLASS_ARROWS,
  arrow: CLASS_ARROW,
  prev: CLASS_ARROW_PREV,
  next: CLASS_ARROW_NEXT,
  pagination: CLASS_PAGINATION,
  page: CLASS_PAGINATION_PAGE,
  spinner: CLASS_SPINNER
};

function Elements(Splide2, Components2, options) {
  var _EventInterface = EventInterface(Splide2),
      on = _EventInterface.on;

  var root = Splide2.root;
  var elements = {};
  var slides = [];
  var classes;
  var slider;
  var track;
  var list;

  function setup() {
    collect();
    identify();
    addClass(root, classes = getClasses());
  }

  function mount() {
    on(EVENT_REFRESH, refresh, DEFAULT_EVENT_PRIORITY - 2);
    on(EVENT_UPDATED, update);
  }

  function destroy() {
    [root, track, list].forEach(function (elm) {
      removeAttribute(elm, "style");
    });
    empty(slides);
    removeClass(root, classes);
  }

  function refresh() {
    destroy();
    setup();
  }

  function update() {
    removeClass(root, classes);
    addClass(root, classes = getClasses());
  }

  function collect() {
    slider = child(root, ".".concat(CLASS_SLIDER));
    track = query(root, ".".concat(CLASS_TRACK));
    list = child(track, ".".concat(CLASS_LIST));
    assert(track && list, "A track/list element is missing.");
    push(slides, children(list, ".".concat(CLASS_SLIDE, ":not(.").concat(CLASS_CLONE, ")")));
    var autoplay = find(".".concat(CLASS_AUTOPLAY));
    var arrows = find(".".concat(CLASS_ARROWS));
    assign(elements, {
      root: root,
      slider: slider,
      track: track,
      list: list,
      slides: slides,
      arrows: arrows,
      autoplay: autoplay,
      prev: query(arrows, ".".concat(CLASS_ARROW_PREV)),
      next: query(arrows, ".".concat(CLASS_ARROW_NEXT)),
      bar: query(find(".".concat(CLASS_PROGRESS)), ".".concat(CLASS_PROGRESS_BAR)),
      play: query(autoplay, ".".concat(CLASS_PLAY)),
      pause: query(autoplay, ".".concat(CLASS_PAUSE))
    });
  }

  function identify() {
    var id = root.id || uniqueId(PROJECT_CODE);
    root.id = id;
    track.id = track.id || "".concat(id, "-track");
    list.id = list.id || "".concat(id, "-list");
  }

  function find(selector) {
    return child(root, selector) || child(slider, selector);
  }

  function getClasses() {
    return ["".concat(CLASS_ROOT, "--").concat(options.type), "".concat(CLASS_ROOT, "--").concat(options.direction), options.drag && "".concat(CLASS_ROOT, "--draggable"), options.isNavigation && "".concat(CLASS_ROOT, "--nav"), CLASS_ACTIVE];
  }

  return assign(elements, {
    setup: setup,
    mount: mount,
    destroy: destroy
  });
}

var ROLE = "role";
var ARIA_CONTROLS = "aria-controls";
var ARIA_CURRENT = "aria-current";
var ARIA_LABEL = "aria-label";
var ARIA_HIDDEN = "aria-hidden";
var TAB_INDEX = "tabindex";
var DISABLED = "disabled";
var ARIA_ORIENTATION = "aria-orientation";
var ALL_ATTRIBUTES = [ROLE, ARIA_CONTROLS, ARIA_CURRENT, ARIA_LABEL, ARIA_HIDDEN, ARIA_ORIENTATION, TAB_INDEX, DISABLED];
var SLIDE = "slide";
var LOOP = "loop";
var FADE = "fade";

function Slide$1(Splide2, index, slideIndex, slide) {
  var _EventInterface2 = EventInterface(Splide2),
      on = _EventInterface2.on,
      emit = _EventInterface2.emit,
      bind = _EventInterface2.bind,
      destroyEvents = _EventInterface2.destroy;

  var Components = Splide2.Components,
      root = Splide2.root,
      options = Splide2.options;
  var isNavigation = options.isNavigation,
      updateOnMove = options.updateOnMove;
  var resolve = Components.Direction.resolve;
  var styles = getAttribute(slide, "style");
  var isClone = slideIndex > -1;
  var container = child(slide, ".".concat(CLASS_CONTAINER));
  var focusableNodes = options.focusableNodes && queryAll(slide, options.focusableNodes);
  var destroyed;

  function mount() {
    var _this2 = this;

    if (!isClone) {
      slide.id = "".concat(root.id, "-slide").concat(pad(index + 1));
    }

    bind(slide, "click keydown", function (e) {
      emit(e.type === "click" ? EVENT_CLICK : EVENT_SLIDE_KEYDOWN, _this2, e);
    });
    on([EVENT_REFRESH, EVENT_REPOSITIONED, EVENT_MOVED, EVENT_SCROLLED], update.bind(this));
    on(EVENT_NAVIGATION_MOUNTED, initNavigation.bind(this));

    if (updateOnMove) {
      on(EVENT_MOVE, onMove.bind(this));
    }
  }

  function destroy() {
    destroyed = true;
    destroyEvents();
    removeClass(slide, STATUS_CLASSES);
    removeAttribute(slide, ALL_ATTRIBUTES);
    setAttribute(slide, "style", styles);
  }

  function initNavigation() {
    var idx = isClone ? slideIndex : index;
    var label = format(options.i18n.slideX, idx + 1);
    var controls = Splide2.splides.map(function (target) {
      return target.splide.root.id;
    }).join(" ");
    setAttribute(slide, ARIA_LABEL, label);
    setAttribute(slide, ARIA_CONTROLS, controls);
    setAttribute(slide, ROLE, "menuitem");
    updateActivity.call(this, isActive());
  }

  function onMove(next, prev, dest) {
    if (!destroyed) {
      update.call(this);

      if (dest === index) {
        updateActivity.call(this, true);
      }
    }
  }

  function update() {
    if (!destroyed) {
      var currIndex = Splide2.index;
      updateActivity.call(this, isActive());
      updateVisibility.call(this, isVisible());
      toggleClass(slide, CLASS_PREV, index === currIndex - 1);
      toggleClass(slide, CLASS_NEXT, index === currIndex + 1);
    }
  }

  function updateActivity(active) {
    if (active !== hasClass(slide, CLASS_ACTIVE)) {
      toggleClass(slide, CLASS_ACTIVE, active);

      if (isNavigation) {
        setAttribute(slide, ARIA_CURRENT, active || null);
      }

      emit(active ? EVENT_ACTIVE : EVENT_INACTIVE, this);
    }
  }

  function updateVisibility(visible) {
    var ariaHidden = !visible && !isActive();
    setAttribute(slide, ARIA_HIDDEN, ariaHidden || null);
    setAttribute(slide, TAB_INDEX, !ariaHidden && options.slideFocus ? 0 : null);

    if (focusableNodes) {
      focusableNodes.forEach(function (node) {
        setAttribute(node, TAB_INDEX, ariaHidden ? -1 : null);
      });
    }

    if (visible !== hasClass(slide, CLASS_VISIBLE)) {
      toggleClass(slide, CLASS_VISIBLE, visible);
      emit(visible ? EVENT_VISIBLE : EVENT_HIDDEN, this);
    }
  }

  function style$1(prop, value, useContainer) {
    style(useContainer && container || slide, prop, value);
  }

  function isActive() {
    return Splide2.index === index;
  }

  function isVisible() {
    if (Splide2.is(FADE)) {
      return isActive();
    }

    var trackRect = rect(Components.Elements.track);
    var slideRect = rect(slide);
    var left = resolve("left");
    var right = resolve("right");
    return floor(trackRect[left]) <= ceil(slideRect[left]) && floor(slideRect[right]) <= ceil(trackRect[right]);
  }

  function isWithin(from, distance) {
    var diff = abs(from - index);

    if (!isClone && (options.rewind || Splide2.is(LOOP))) {
      diff = min(diff, Splide2.length - diff);
    }

    return diff <= distance;
  }

  return {
    index: index,
    slideIndex: slideIndex,
    slide: slide,
    container: container,
    isClone: isClone,
    mount: mount,
    destroy: destroy,
    style: style$1,
    isWithin: isWithin
  };
}

function Slides(Splide2, Components2, options) {
  var _EventInterface3 = EventInterface(Splide2),
      on = _EventInterface3.on,
      emit = _EventInterface3.emit,
      bind = _EventInterface3.bind;

  var _Components2$Elements = Components2.Elements,
      slides = _Components2$Elements.slides,
      list = _Components2$Elements.list;
  var Slides2 = [];

  function mount() {
    init();
    on(EVENT_REFRESH, refresh);
    on([EVENT_MOUNTED, EVENT_REFRESH], function () {
      Slides2.sort(function (Slide1, Slide2) {
        return Slide1.index - Slide2.index;
      });
    });
  }

  function init() {
    slides.forEach(function (slide, index) {
      register(slide, index, -1);
    });
  }

  function destroy() {
    forEach$1(function (Slide2) {
      Slide2.destroy();
    });
    empty(Slides2);
  }

  function refresh() {
    destroy();
    init();
  }

  function register(slide, index, slideIndex) {
    var object = Slide$1(Splide2, index, slideIndex, slide);
    object.mount();
    Slides2.push(object);
  }

  function get(excludeClones) {
    return excludeClones ? filter(function (Slide2) {
      return !Slide2.isClone;
    }) : Slides2;
  }

  function getIn(page) {
    var Controller = Components2.Controller;
    var index = Controller.toIndex(page);
    var max = Controller.hasFocus() ? 1 : options.perPage;
    return filter(function (Slide2) {
      return between(Slide2.index, index, index + max - 1);
    });
  }

  function getAt(index) {
    return filter(index)[0];
  }

  function add(items, index) {
    forEach(items, function (slide) {
      if (isString(slide)) {
        slide = parseHtml(slide);
      }

      if (isHTMLElement(slide)) {
        var ref = slides[index];
        ref ? before(slide, ref) : append(list, slide);
        addClass(slide, options.classes.slide);
        observeImages(slide, emit.bind(null, EVENT_RESIZE));
      }
    });
    emit(EVENT_REFRESH);
  }

  function remove$1(matcher) {
    remove(filter(matcher).map(function (Slide2) {
      return Slide2.slide;
    }));
    emit(EVENT_REFRESH);
  }

  function forEach$1(iteratee, excludeClones) {
    get(excludeClones).forEach(iteratee);
  }

  function filter(matcher) {
    return Slides2.filter(isFunction(matcher) ? matcher : function (Slide2) {
      return isString(matcher) ? matches(Slide2.slide, matcher) : includes(toArray(matcher), Slide2.index);
    });
  }

  function style(prop, value, useContainer) {
    forEach$1(function (Slide2) {
      Slide2.style(prop, value, useContainer);
    });
  }

  function observeImages(elm, callback) {
    var images = queryAll(elm, "img");
    var length = images.length;

    if (length) {
      images.forEach(function (img) {
        bind(img, "load error", function () {
          if (! --length) {
            callback();
          }
        });
      });
    } else {
      callback();
    }
  }

  function getLength(excludeClones) {
    return excludeClones ? slides.length : Slides2.length;
  }

  function isEnough() {
    return Slides2.length > options.perPage;
  }

  return {
    mount: mount,
    destroy: destroy,
    register: register,
    get: get,
    getIn: getIn,
    getAt: getAt,
    add: add,
    remove: remove$1,
    forEach: forEach$1,
    filter: filter,
    style: style,
    getLength: getLength,
    isEnough: isEnough
  };
}

function Layout(Splide2, Components2, options) {
  var _EventInterface4 = EventInterface(Splide2),
      on = _EventInterface4.on,
      bind = _EventInterface4.bind,
      emit = _EventInterface4.emit;

  var Slides = Components2.Slides;
  var resolve = Components2.Direction.resolve;
  var _Components2$Elements2 = Components2.Elements,
      root = _Components2$Elements2.root,
      track = _Components2$Elements2.track,
      list = _Components2$Elements2.list;
  var getAt = Slides.getAt;
  var vertical;
  var rootRect;

  function mount() {
    init();
    bind(window, "resize load", Throttle(emit.bind(this, EVENT_RESIZE)));
    on([EVENT_UPDATED, EVENT_REFRESH], init);
    on(EVENT_RESIZE, resize);
  }

  function init() {
    rootRect = null;
    vertical = options.direction === TTB;
    style(root, "maxWidth", unit(options.width));
    style(track, resolve("paddingLeft"), cssPadding(false));
    style(track, resolve("paddingRight"), cssPadding(true));
    resize();
  }

  function resize() {
    var newRect = rect(root);

    if (!rootRect || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
      style(track, "height", cssTrackHeight());
      Slides.style(resolve("marginRight"), unit(options.gap));
      Slides.style("width", cssSlideWidth() || null);
      setSlidesHeight();
      rootRect = newRect;
      emit(EVENT_RESIZED);
    }
  }

  function setSlidesHeight() {
    Slides.style("height", cssSlideHeight() || null, true);
  }

  function cssPadding(right) {
    var padding = options.padding;
    var prop = resolve(right ? "right" : "left");
    return padding && unit(padding[prop] || (isObject(padding) ? 0 : padding)) || "0px";
  }

  function cssTrackHeight() {
    var height = "";

    if (vertical) {
      height = cssHeight();
      assert(height, "height or heightRatio is missing.");
      height = "calc(".concat(height, " - ").concat(cssPadding(false), " - ").concat(cssPadding(true), ")");
    }

    return height;
  }

  function cssHeight() {
    return unit(options.height || rect(list).width * options.heightRatio);
  }

  function cssSlideWidth() {
    return options.autoWidth ? "" : unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
  }

  function cssSlideHeight() {
    return unit(options.fixedHeight) || (vertical ? options.autoHeight ? "" : cssSlideSize() : cssHeight());
  }

  function cssSlideSize() {
    var gap = unit(options.gap);
    return "calc((100%".concat(gap && " + ".concat(gap), ")/").concat(options.perPage || 1).concat(gap && " - ".concat(gap), ")");
  }

  function listSize() {
    return rect(list)[resolve("width")];
  }

  function slideSize(index, withoutGap) {
    var Slide = getAt(index || 0);
    return Slide ? rect(Slide.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
  }

  function totalSize(index, withoutGap) {
    var Slide = getAt(index);

    if (Slide) {
      var right = rect(Slide.slide)[resolve("right")];
      var left = rect(list)[resolve("left")];
      return abs(right - left) + (withoutGap ? 0 : getGap());
    }

    return 0;
  }

  function sliderSize() {
    return totalSize(Splide2.length - 1, true) - totalSize(-1, true);
  }

  function getGap() {
    var Slide = getAt(0);
    return Slide && parseFloat(style(Slide.slide, resolve("marginRight"))) || 0;
  }

  function getPadding(right) {
    return parseFloat(style(track, resolve("padding".concat(right ? "Right" : "Left")))) || 0;
  }

  return {
    mount: mount,
    listSize: listSize,
    slideSize: slideSize,
    sliderSize: sliderSize,
    totalSize: totalSize,
    getPadding: getPadding
  };
}

function Clones(Splide2, Components2, options) {
  var _EventInterface5 = EventInterface(Splide2),
      on = _EventInterface5.on,
      emit = _EventInterface5.emit;

  var Elements = Components2.Elements,
      Slides = Components2.Slides;
  var resolve = Components2.Direction.resolve;
  var clones = [];
  var cloneCount;

  function mount() {
    init();
    on(EVENT_REFRESH, refresh);
    on([EVENT_UPDATED, EVENT_RESIZE], observe);
  }

  function init() {
    if (cloneCount = computeCloneCount()) {
      generate(cloneCount);
      emit(EVENT_RESIZE);
    }
  }

  function destroy() {
    remove(clones);
    empty(clones);
  }

  function refresh() {
    destroy();
    init();
  }

  function observe() {
    if (cloneCount < computeCloneCount()) {
      emit(EVENT_REFRESH);
    }
  }

  function generate(count) {
    var slides = Slides.get().slice();
    var length = slides.length;

    if (length) {
      while (slides.length < count) {
        push(slides, slides);
      }

      push(slides.slice(-count), slides.slice(0, count)).forEach(function (Slide, index) {
        var isHead = index < count;
        var clone = cloneDeep(Slide.slide, index);
        isHead ? before(clone, slides[0].slide) : append(Elements.list, clone);
        push(clones, clone);
        Slides.register(clone, index - count + (isHead ? 0 : length), Slide.index);
      });
    }
  }

  function cloneDeep(elm, index) {
    var clone = elm.cloneNode(true);
    addClass(clone, options.classes.clone);
    clone.id = "".concat(Splide2.root.id, "-clone").concat(pad(index + 1));
    return clone;
  }

  function computeCloneCount() {
    var clones2 = options.clones;

    if (!Splide2.is(LOOP)) {
      clones2 = 0;
    } else if (!clones2) {
      var fixedSize = measure(Elements.list, options[resolve("fixedWidth")]);
      var fixedCount = fixedSize && ceil(rect(Elements.track)[resolve("width")] / fixedSize);
      var baseCount = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage;
      clones2 = baseCount * (options.drag ? (options.flickMaxPages || 1) + 1 : 2);
    }

    return clones2;
  }

  return {
    mount: mount,
    destroy: destroy
  };
}

function Move(Splide2, Components2, options) {
  var _EventInterface6 = EventInterface(Splide2),
      on = _EventInterface6.on,
      emit = _EventInterface6.emit;

  var _Components2$Layout = Components2.Layout,
      slideSize = _Components2$Layout.slideSize,
      getPadding = _Components2$Layout.getPadding,
      totalSize = _Components2$Layout.totalSize,
      listSize = _Components2$Layout.listSize,
      sliderSize = _Components2$Layout.sliderSize;
  var _Components2$Directio = Components2.Direction,
      resolve = _Components2$Directio.resolve,
      orient = _Components2$Directio.orient;
  var _Components2$Elements3 = Components2.Elements,
      list = _Components2$Elements3.list,
      track = _Components2$Elements3.track;
  var Transition;

  function mount() {
    Transition = Components2.Transition;
    on([EVENT_MOUNTED, EVENT_RESIZED, EVENT_UPDATED, EVENT_REFRESH], reposition);
  }

  function destroy() {
    removeAttribute(list, "style");
  }

  function reposition() {
    if (!isBusy()) {
      Components2.Scroll.cancel();
      jump(Splide2.index);
      emit(EVENT_REPOSITIONED);
    }
  }

  function move(dest, index, prev, callback) {
    if (!isBusy()) {
      var set = Splide2.state.set;
      var position = getPosition();

      if (dest !== index) {
        Transition.cancel();
        translate(shift(position, dest > index), true);
      }

      set(MOVING);
      emit(EVENT_MOVE, index, prev, dest);
      Transition.start(index, function () {
        set(IDLE);
        emit(EVENT_MOVED, index, prev, dest);

        if (options.trimSpace === "move" && dest !== prev && position === getPosition()) {
          Components2.Controller.go(dest > prev ? ">" : "<", false, callback);
        } else {
          callback && callback();
        }
      });
    }
  }

  function jump(index) {
    translate(toPosition(index, true));
  }

  function translate(position, preventLoop) {
    if (!Splide2.is(FADE)) {
      list.style.transform = "translate".concat(resolve("X"), "(").concat(preventLoop ? position : loop(position), "px)");
    }
  }

  function loop(position) {
    if (Splide2.is(LOOP)) {
      var diff = orient(position - getPosition());
      var exceededMin = exceededLimit(false, position) && diff < 0;
      var exceededMax = exceededLimit(true, position) && diff > 0;

      if (exceededMin || exceededMax) {
        position = shift(position, exceededMax);
      }
    }

    return position;
  }

  function shift(position, backwards) {
    var excess = position - getLimit(backwards);
    var size = sliderSize();
    position -= orient(size * (ceil(abs(excess) / size) || 1)) * (backwards ? 1 : -1);
    return position;
  }

  function cancel() {
    translate(getPosition());
    Transition.cancel();
  }

  function toIndex(position) {
    var Slides = Components2.Slides.get();
    var index = 0;
    var minDistance = Infinity;

    for (var i = 0; i < Slides.length; i++) {
      var slideIndex = Slides[i].index;
      var distance = abs(toPosition(slideIndex, true) - position);

      if (distance <= minDistance) {
        minDistance = distance;
        index = slideIndex;
      } else {
        break;
      }
    }

    return index;
  }

  function toPosition(index, trimming) {
    var position = orient(totalSize(index - 1) - offset(index));
    return trimming ? trim(position) : position;
  }

  function getPosition() {
    var left = resolve("left");
    return rect(list)[left] - rect(track)[left] + orient(getPadding(false));
  }

  function trim(position) {
    if (options.trimSpace && Splide2.is(SLIDE)) {
      position = clamp(position, 0, orient(sliderSize() - listSize()));
    }

    return position;
  }

  function offset(index) {
    var focus = options.focus;
    return focus === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus * slideSize(index) || 0;
  }

  function getLimit(max) {
    return toPosition(max ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
  }

  function isBusy() {
    return Splide2.state.is(MOVING) && options.waitForTransition;
  }

  function exceededLimit(max, position) {
    position = isUndefined(position) ? getPosition() : position;
    var exceededMin = max !== true && orient(position) < orient(getLimit(false));
    var exceededMax = max !== false && orient(position) > orient(getLimit(true));
    return exceededMin || exceededMax;
  }

  return {
    mount: mount,
    destroy: destroy,
    move: move,
    jump: jump,
    translate: translate,
    shift: shift,
    cancel: cancel,
    toIndex: toIndex,
    toPosition: toPosition,
    getPosition: getPosition,
    getLimit: getLimit,
    isBusy: isBusy,
    exceededLimit: exceededLimit
  };
}

function Controller(Splide2, Components2, options) {
  var _EventInterface7 = EventInterface(Splide2),
      on = _EventInterface7.on;

  var Move = Components2.Move;
  var getPosition = Move.getPosition,
      getLimit = Move.getLimit;
  var _Components2$Slides = Components2.Slides,
      isEnough = _Components2$Slides.isEnough,
      getLength = _Components2$Slides.getLength;
  var isLoop = Splide2.is(LOOP);
  var isSlide = Splide2.is(SLIDE);
  var currIndex = options.start || 0;
  var prevIndex = currIndex;
  var slideCount;
  var perMove;
  var perPage;

  function mount() {
    init();
    on([EVENT_UPDATED, EVENT_REFRESH], init, DEFAULT_EVENT_PRIORITY - 1);
  }

  function init() {
    slideCount = getLength(true);
    perMove = options.perMove;
    perPage = options.perPage;
    currIndex = clamp(currIndex, 0, slideCount - 1);
  }

  function go(control, allowSameIndex, callback) {
    var dest = parse(control);

    if (options.useScroll) {
      scroll(dest, true, true, options.speed, callback);
    } else {
      var index = loop(dest);

      if (index > -1 && !Move.isBusy() && (allowSameIndex || index !== currIndex)) {
        setIndex(index);
        Move.move(dest, index, prevIndex, callback);
      }
    }
  }

  function scroll(destination, useIndex, snap, duration, callback) {
    var dest = useIndex ? destination : toDest(destination);
    Components2.Scroll.scroll(useIndex || snap ? Move.toPosition(dest, true) : destination, duration, function () {
      setIndex(Move.toIndex(Move.getPosition()));
      callback && callback();
    });
  }

  function parse(control) {
    var index = currIndex;

    if (isString(control)) {
      var _ref = control.match(/([+\-<>])(\d+)?/) || [],
          _ref2 = _slicedToArray(_ref, 3),
          indicator = _ref2[1],
          number = _ref2[2];

      if (indicator === "+" || indicator === "-") {
        index = computeDestIndex(currIndex + +"".concat(indicator).concat(+number || 1), currIndex, true);
      } else if (indicator === ">") {
        index = number ? toIndex(+number) : getNext(true);
      } else if (indicator === "<") {
        index = getPrev(true);
      }
    } else {
      index = isLoop ? control : clamp(control, 0, getEnd());
    }

    return index;
  }

  function getNext(destination) {
    return getAdjacent(false, destination);
  }

  function getPrev(destination) {
    return getAdjacent(true, destination);
  }

  function getAdjacent(prev, destination) {
    var number = perMove || (hasFocus() ? 1 : perPage);
    var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex);

    if (dest === -1 && isSlide) {
      if (!approximatelyEqual(getPosition(), getLimit(!prev), 1)) {
        return prev ? 0 : getEnd();
      }
    }

    return destination ? dest : loop(dest);
  }

  function computeDestIndex(dest, from, incremental) {
    if (isEnough()) {
      var end = getEnd();

      if (dest < 0 || dest > end) {
        if (between(0, dest, from, true) || between(end, from, dest, true)) {
          dest = toIndex(toPage(dest));
        } else {
          if (isLoop) {
            dest = perMove ? dest : dest < 0 ? -(slideCount % perPage || perPage) : slideCount;
          } else if (options.rewind) {
            dest = dest < 0 ? end : 0;
          } else {
            dest = -1;
          }
        }
      } else {
        if (!incremental && dest !== from) {
          dest = perMove ? dest : toIndex(toPage(from) + (dest < from ? -1 : 1));
        }
      }
    } else {
      dest = -1;
    }

    return dest;
  }

  function getEnd() {
    var end = slideCount - perPage;

    if (hasFocus() || isLoop && perMove) {
      end = slideCount - 1;
    }

    return max(end, 0);
  }

  function loop(index) {
    if (isLoop) {
      return isEnough() ? index % slideCount + (index < 0 ? slideCount : 0) : -1;
    }

    return index;
  }

  function toIndex(page) {
    return clamp(hasFocus() ? page : perPage * page, 0, getEnd());
  }

  function toPage(index) {
    if (!hasFocus()) {
      index = between(index, slideCount - perPage, slideCount - 1) ? slideCount - 1 : index;
      index = floor(index / perPage);
    }

    return index;
  }

  function toDest(destination) {
    var closest = Move.toIndex(destination);
    return isSlide ? clamp(closest, 0, getEnd()) : closest;
  }

  function setIndex(index) {
    if (index !== currIndex) {
      prevIndex = currIndex;
      currIndex = index;
    }
  }

  function getIndex(prev) {
    return prev ? prevIndex : currIndex;
  }

  function hasFocus() {
    return !isUndefined(options.focus) || options.isNavigation;
  }

  return {
    mount: mount,
    go: go,
    scroll: scroll,
    getNext: getNext,
    getPrev: getPrev,
    getEnd: getEnd,
    setIndex: setIndex,
    getIndex: getIndex,
    toIndex: toIndex,
    toPage: toPage,
    toDest: toDest,
    hasFocus: hasFocus
  };
}

var XML_NAME_SPACE = "http://www.w3.org/2000/svg";
var PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
var SIZE = 40;

function Arrows(Splide2, Components2, options) {
  var _EventInterface8 = EventInterface(Splide2),
      on = _EventInterface8.on,
      bind = _EventInterface8.bind,
      emit = _EventInterface8.emit;

  var classes = options.classes,
      i18n = options.i18n;
  var Elements = Components2.Elements,
      Controller = Components2.Controller;
  var wrapper = Elements.arrows;
  var prev = Elements.prev;
  var next = Elements.next;
  var created;
  var arrows = {};

  function mount() {
    init();
    on(EVENT_UPDATED, init);
  }

  function init() {
    if (options.arrows) {
      if (!prev || !next) {
        createArrows();
      }
    }

    if (prev && next) {
      if (!arrows.prev) {
        var id = Elements.track.id;
        setAttribute(prev, ARIA_CONTROLS, id);
        setAttribute(next, ARIA_CONTROLS, id);
        arrows.prev = prev;
        arrows.next = next;
        listen();
        emit(EVENT_ARROWS_MOUNTED, prev, next);
      } else {
        display(wrapper, options.arrows === false ? "none" : "");
      }
    }
  }

  function destroy() {
    if (created) {
      remove(wrapper);
    } else {
      removeAttribute(prev, ALL_ATTRIBUTES);
      removeAttribute(next, ALL_ATTRIBUTES);
    }
  }

  function listen() {
    var go = Controller.go;
    on([EVENT_MOUNTED, EVENT_MOVED, EVENT_UPDATED, EVENT_REFRESH, EVENT_SCROLLED], update);
    bind(next, "click", function () {
      go(">", true);
    });
    bind(prev, "click", function () {
      go("<", true);
    });
  }

  function createArrows() {
    wrapper = create("div", classes.arrows);
    prev = createArrow(true);
    next = createArrow(false);
    created = true;
    append(wrapper, [prev, next]);
    before(wrapper, child(options.arrows === "slider" && Elements.slider || Splide2.root));
  }

  function createArrow(prev2) {
    var arrow = "<button class=\"".concat(classes.arrow, " ").concat(prev2 ? classes.prev : classes.next, "\" type=\"button\"><svg xmlns=\"").concat(XML_NAME_SPACE, "\" viewBox=\"0 0 ").concat(SIZE, " ").concat(SIZE, "\" width=\"").concat(SIZE, "\" height=\"").concat(SIZE, "\"><path d=\"").concat(options.arrowPath || PATH, "\" />");
    return parseHtml(arrow);
  }

  function update() {
    var index = Splide2.index;
    var prevIndex = Controller.getPrev();
    var nextIndex = Controller.getNext();
    var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
    var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
    prev.disabled = prevIndex < 0;
    next.disabled = nextIndex < 0;
    setAttribute(prev, ARIA_LABEL, prevLabel);
    setAttribute(next, ARIA_LABEL, nextLabel);
    emit(EVENT_ARROWS_UPDATED, prev, next, prevIndex, nextIndex);
  }

  return {
    arrows: arrows,
    mount: mount,
    destroy: destroy
  };
}

function Autoplay(Splide2, Components2, options) {
  var _EventInterface9 = EventInterface(Splide2),
      on = _EventInterface9.on,
      bind = _EventInterface9.bind,
      emit = _EventInterface9.emit;

  var Elements = Components2.Elements;
  var interval = RequestInterval(options.interval, Splide2.go.bind(Splide2, ">"), update);
  var isPaused = interval.isPaused;
  var hovered;
  var focused;
  var paused;

  function mount() {
    var autoplay = options.autoplay;

    if (autoplay) {
      initButton(true);
      initButton(false);
      listen();

      if (autoplay !== "pause") {
        play();
      }
    }
  }

  function initButton(forPause) {
    var prop = forPause ? "pause" : "play";
    var button = Elements[prop];

    if (button) {
      setAttribute(button, ARIA_CONTROLS, Elements.track.id);
      setAttribute(button, ARIA_LABEL, options.i18n[prop]);
      bind(button, "click", forPause ? pause : play);
    }
  }

  function listen() {
    var root = Elements.root;

    if (options.pauseOnHover) {
      bind(root, "mouseenter mouseleave", function (e) {
        hovered = e.type === "mouseenter";
        autoToggle();
      });
    }

    if (options.pauseOnFocus) {
      bind(root, "focusin focusout", function (e) {
        focused = e.type === "focusin";
        autoToggle();
      });
    }

    on([EVENT_MOVE, EVENT_SCROLL, EVENT_REFRESH], interval.rewind);
  }

  function play() {
    if (isPaused() && Components2.Slides.isEnough()) {
      interval.start(!options.resetProgress);
      focused = hovered = paused = false;
      emit(EVENT_AUTOPLAY_PLAY);
    }
  }

  function pause() {
    var manual = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    if (!isPaused()) {
      interval.pause();
      emit(EVENT_AUTOPLAY_PAUSE);
    }

    paused = manual;
  }

  function autoToggle() {
    if (!paused) {
      if (!hovered && !focused) {
        play();
      } else {
        pause(false);
      }
    }
  }

  function update(rate) {
    var bar = Elements.bar;

    if (bar) {
      style(bar, "width", "".concat(rate * 100, "%"));
    }

    emit(EVENT_AUTOPLAY_PLAYING, rate);
  }

  return {
    mount: mount,
    destroy: interval.cancel,
    play: play,
    pause: pause,
    isPaused: isPaused
  };
}

function Cover(Splide2, Components2, options) {
  var _EventInterface10 = EventInterface(Splide2),
      on = _EventInterface10.on;

  function mount() {
    if (options.cover) {
      on(EVENT_LAZYLOAD_LOADED, function (img, Slide) {
        toggle(true, img, Slide);
      });
      on([EVENT_MOUNTED, EVENT_UPDATED, EVENT_REFRESH], apply.bind(null, true));
    }
  }

  function destroy() {
    apply(false);
  }

  function apply(cover) {
    Components2.Slides.forEach(function (Slide) {
      var img = child(Slide.container || Slide.slide, "img");

      if (img && img.src) {
        toggle(cover, img, Slide);
      }
    });
  }

  function toggle(cover, img, Slide) {
    Slide.style("background", cover ? "center/cover no-repeat url(\"".concat(img.src, "\")") : "", true);
    display(img, cover ? "none" : "");
  }

  return {
    mount: mount,
    destroy: destroy
  };
}

var BOUNCE_DIFF_THRESHOLD = 10;
var BOUNCE_DURATION = 600;
var FRICTION_FACTOR = 0.6;
var BASE_VELOCITY = 1.5;
var MIN_DURATION = 800;

function Scroll(Splide2, Components2, options) {
  var _EventInterface11 = EventInterface(Splide2),
      on = _EventInterface11.on,
      emit = _EventInterface11.emit;

  var Move = Components2.Move;
  var getPosition = Move.getPosition,
      getLimit = Move.getLimit,
      exceededLimit = Move.exceededLimit;
  var interval;
  var scrollCallback;

  function mount() {
    on(EVENT_MOVE, clear);
    on([EVENT_UPDATED, EVENT_REFRESH], cancel);
  }

  function scroll(destination, duration, callback, suppressConstraint) {
    var start = getPosition();
    var friction = 1;
    duration = duration || computeDuration(abs(destination - start));
    scrollCallback = callback;
    clear();
    interval = RequestInterval(duration, onScrolled, function (rate) {
      var position = getPosition();
      var target = start + (destination - start) * easing(rate);
      var diff = (target - getPosition()) * friction;
      Move.translate(position + diff);

      if (Splide2.is(SLIDE) && !suppressConstraint && exceededLimit()) {
        friction *= FRICTION_FACTOR;

        if (abs(diff) < BOUNCE_DIFF_THRESHOLD) {
          bounce(exceededLimit(false));
        }
      }
    }, 1);
    emit(EVENT_SCROLL);
    interval.start();
  }

  function bounce(backwards) {
    scroll(getLimit(!backwards), BOUNCE_DURATION, null, true);
  }

  function onScrolled() {
    var position = getPosition();
    var index = Move.toIndex(position);

    if (!between(index, 0, Splide2.length - 1)) {
      Move.translate(Move.shift(position, index > 0), true);
    }

    scrollCallback && scrollCallback();
    emit(EVENT_SCROLLED);
  }

  function computeDuration(distance) {
    return max(distance / BASE_VELOCITY, MIN_DURATION);
  }

  function clear() {
    if (interval) {
      interval.cancel();
    }
  }

  function cancel() {
    if (interval && !interval.isPaused()) {
      clear();
      onScrolled();
    }
  }

  function easing(t) {
    var easingFunc = options.easingFunc;
    return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
  }

  return {
    mount: mount,
    destroy: clear,
    scroll: scroll,
    cancel: cancel
  };
}

var FRICTION = 5;
var LOG_INTERVAL = 200;
var POINTER_DOWN_EVENTS = "touchstart mousedown";
var POINTER_MOVE_EVENTS = "touchmove mousemove";
var POINTER_UP_EVENTS = "touchend touchcancel mouseup";

function Drag(Splide2, Components2, options) {
  var _EventInterface12 = EventInterface(Splide2),
      on = _EventInterface12.on,
      emit = _EventInterface12.emit,
      bind = _EventInterface12.bind,
      unbind = _EventInterface12.unbind;

  var Move = Components2.Move,
      Scroll = Components2.Scroll,
      Controller = Components2.Controller;
  var track = Components2.Elements.track;
  var _Components2$Directio2 = Components2.Direction,
      resolve = _Components2$Directio2.resolve,
      orient = _Components2$Directio2.orient;
  var getPosition = Move.getPosition,
      exceededLimit = Move.exceededLimit;
  var listenerOptions = {
    passive: false,
    capture: true
  };
  var basePosition;
  var baseEvent;
  var prevBaseEvent;
  var lastEvent;
  var isFree;
  var dragging;
  var hasExceeded = false;
  var clickPrevented;
  var disabled;
  var target;

  function mount() {
    bind(track, POINTER_MOVE_EVENTS, noop, listenerOptions);
    bind(track, POINTER_UP_EVENTS, noop, listenerOptions);
    bind(track, POINTER_DOWN_EVENTS, onPointerDown, listenerOptions);
    bind(track, "click", onClick, {
      capture: true
    });
    bind(track, "dragstart", prevent);
    on([EVENT_MOUNTED, EVENT_UPDATED], init);
  }

  function init() {
    var drag = options.drag;
    disable(!drag);
    isFree = drag === "free";
  }

  function onPointerDown(e) {
    if (!disabled) {
      var noDrag = options.noDrag;
      var isTouch = isTouchEvent(e);
      var isDraggable = !noDrag || isHTMLElement(e.target) && !matches(e.target, noDrag);

      if (isDraggable && (isTouch || !e.button)) {
        if (!Move.isBusy()) {
          target = isTouch ? track : window;
          prevBaseEvent = null;
          lastEvent = null;
          clickPrevented = false;
          bind(target, POINTER_MOVE_EVENTS, onPointerMove, listenerOptions);
          bind(target, POINTER_UP_EVENTS, onPointerUp, listenerOptions);
          Move.cancel();
          Scroll.cancel();
          save(e);
        } else {
          prevent(e, true);
        }
      }
    }
  }

  function onPointerMove(e) {
    if (!lastEvent) {
      emit(EVENT_DRAG);
    }

    lastEvent = e;

    if (e.cancelable) {
      var diff = coordOf(e) - coordOf(baseEvent);

      if (dragging) {
        Move.translate(basePosition + constrain(diff));
        var expired = timeOf(e) - timeOf(baseEvent) > LOG_INTERVAL;
        var exceeded = hasExceeded !== (hasExceeded = exceededLimit());

        if (expired || exceeded) {
          save(e);
        }

        emit(EVENT_DRAGGING);
        clickPrevented = true;
        prevent(e);
      } else {
        var thresholds = options.dragMinThreshold;
        thresholds = isObject(thresholds) ? thresholds : {
          mouse: 0,
          touch: +thresholds || 10
        };
        dragging = abs(diff) > (isTouchEvent(e) ? thresholds.touch : thresholds.mouse);

        if (isSliderDirection()) {
          prevent(e);
        }
      }
    }
  }

  function onPointerUp(e) {
    unbind(target, POINTER_MOVE_EVENTS, onPointerMove);
    unbind(target, POINTER_UP_EVENTS, onPointerUp);

    if (lastEvent) {
      if (dragging || e.cancelable && isSliderDirection()) {
        var velocity = computeVelocity(e);
        var destination = computeDestination(velocity);

        if (isFree) {
          Controller.scroll(destination);
        } else if (Splide2.is(FADE)) {
          Controller.go(Splide2.index + orient(sign(velocity)));
        } else {
          Controller.go(Controller.toDest(destination), true);
        }

        prevent(e);
      }

      emit(EVENT_DRAGGED);
    } else {
      if (!isFree) {
        Controller.go(Splide2.index, true);
      }
    }

    dragging = false;
  }

  function save(e) {
    prevBaseEvent = baseEvent;
    baseEvent = e;
    basePosition = getPosition();
  }

  function onClick(e) {
    if (!disabled && clickPrevented) {
      prevent(e, true);
    }
  }

  function isSliderDirection() {
    var diffX = abs(coordOf(lastEvent) - coordOf(baseEvent));
    var diffY = abs(coordOf(lastEvent, true) - coordOf(baseEvent, true));
    return diffX > diffY;
  }

  function computeVelocity(e) {
    if (Splide2.is(LOOP) || !hasExceeded) {
      var base = baseEvent === lastEvent && prevBaseEvent || baseEvent;
      var diffCoord = coordOf(lastEvent) - coordOf(base);
      var diffTime = timeOf(e) - timeOf(base);
      var isFlick = timeOf(e) - timeOf(lastEvent) < LOG_INTERVAL;

      if (diffTime && isFlick) {
        return diffCoord / diffTime;
      }
    }

    return 0;
  }

  function computeDestination(velocity) {
    return getPosition() + sign(velocity) * min(abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
  }

  function coordOf(e, orthogonal) {
    return (isTouchEvent(e) ? e.touches[0] : e)["page".concat(resolve(orthogonal ? "Y" : "X"))];
  }

  function timeOf(e) {
    return e.timeStamp;
  }

  function constrain(diff) {
    return diff / (hasExceeded && Splide2.is(SLIDE) ? FRICTION : 1);
  }

  function isTouchEvent(e) {
    return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
  }

  function isDragging() {
    return dragging;
  }

  function disable(value) {
    disabled = value;
  }

  return {
    mount: mount,
    disable: disable,
    isDragging: isDragging
  };
}

var IE_ARROW_KEYS = ["Left", "Right", "Up", "Down"];

function Keyboard(Splide2, Components2, options) {
  var _EventInterface13 = EventInterface(Splide2),
      on = _EventInterface13.on,
      bind = _EventInterface13.bind,
      unbind = _EventInterface13.unbind;

  var root = Components2.Elements.root;
  var resolve = Components2.Direction.resolve;
  var target;
  var disabled;

  function mount() {
    init();
    on(EVENT_UPDATED, onUpdated);
    on(EVENT_MOVE, onMove);
  }

  function init() {
    var _options$keyboard = options.keyboard,
        keyboard = _options$keyboard === void 0 ? "global" : _options$keyboard;

    if (keyboard) {
      if (keyboard === "focused") {
        target = root;
        setAttribute(root, TAB_INDEX, 0);
      } else {
        target = window;
      }

      bind(target, "keydown", onKeydown);
    }
  }

  function destroy() {
    unbind(target, "keydown");

    if (isHTMLElement(target)) {
      removeAttribute(target, TAB_INDEX);
    }
  }

  function onMove() {
    disabled = true;
    nextTick(function () {
      disabled = false;
    });
  }

  function onUpdated() {
    destroy();
    init();
  }

  function onKeydown(e) {
    if (!disabled) {
      var key = e.key;
      var normalizedKey = includes(IE_ARROW_KEYS, key) ? "Arrow".concat(key) : key;

      if (normalizedKey === resolve("ArrowLeft")) {
        Splide2.go("<");
      } else if (normalizedKey === resolve("ArrowRight")) {
        Splide2.go(">");
      }
    }
  }

  return {
    mount: mount,
    destroy: destroy
  };
}

var SRC_DATA_ATTRIBUTE = "".concat(DATA_ATTRIBUTE, "-lazy");
var SRCSET_DATA_ATTRIBUTE = "".concat(SRC_DATA_ATTRIBUTE, "-srcset");
var IMAGE_SELECTOR = "[".concat(SRC_DATA_ATTRIBUTE, "], [").concat(SRCSET_DATA_ATTRIBUTE, "]");

function LazyLoad(Splide2, Components2, options) {
  var _EventInterface14 = EventInterface(Splide2),
      on = _EventInterface14.on,
      off = _EventInterface14.off,
      bind = _EventInterface14.bind,
      emit = _EventInterface14.emit;

  var isSequential = options.lazyLoad === "sequential";
  var images = [];
  var index = 0;

  function mount() {
    if (options.lazyLoad) {
      on([EVENT_MOUNTED, EVENT_REFRESH], function () {
        destroy();
        init();
      });

      if (!isSequential) {
        on([EVENT_MOUNTED, EVENT_REFRESH, EVENT_MOVED], observe);
      }
    }
  }

  function init() {
    Components2.Slides.forEach(function (_Slide) {
      queryAll(_Slide.slide, IMAGE_SELECTOR).forEach(function (_img) {
        var src = getAttribute(_img, SRC_DATA_ATTRIBUTE);
        var srcset = getAttribute(_img, SRCSET_DATA_ATTRIBUTE);

        if (src !== _img.src || srcset !== _img.srcset) {
          var _spinner = create("span", options.classes.spinner, _img.parentElement);

          setAttribute(_spinner, ROLE, "presentation");
          images.push({
            _img: _img,
            _Slide: _Slide,
            src: src,
            srcset: srcset,
            _spinner: _spinner
          });
          !_img.src && display(_img, "none");
        }
      });
    });

    if (isSequential) {
      loadNext();
    }
  }

  function destroy() {
    index = 0;
    images = [];
  }

  function observe() {
    images = images.filter(function (data) {
      var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;

      if (data._Slide.isWithin(Splide2.index, distance)) {
        return load(data);
      }

      return true;
    });

    if (!images.length) {
      off(EVENT_MOVED);
    }
  }

  function load(data) {
    var _img = data._img;
    addClass(data._Slide.slide, CLASS_LOADING);
    bind(_img, "load error", function (e) {
      onLoad(data, e.type === "error");
    });
    ["src", "srcset"].forEach(function (name) {
      if (data[name]) {
        setAttribute(_img, name, data[name]);
        removeAttribute(_img, name === "src" ? SRC_DATA_ATTRIBUTE : SRCSET_DATA_ATTRIBUTE);
      }
    });
  }

  function onLoad(data, error) {
    var _Slide = data._Slide;
    removeClass(_Slide.slide, CLASS_LOADING);

    if (!error) {
      remove(data._spinner);
      display(data._img, "");
      emit(EVENT_LAZYLOAD_LOADED, data._img, _Slide);
      emit(EVENT_RESIZE);
    }

    if (isSequential) {
      loadNext();
    }
  }

  function loadNext() {
    if (index < images.length) {
      load(images[index++]);
    }
  }

  return {
    mount: mount,
    destroy: destroy
  };
}

function Pagination(Splide2, Components2, options) {
  var _EventInterface15 = EventInterface(Splide2),
      on = _EventInterface15.on,
      emit = _EventInterface15.emit,
      bind = _EventInterface15.bind,
      unbind = _EventInterface15.unbind;

  var Slides = Components2.Slides,
      Elements = Components2.Elements,
      Controller = Components2.Controller;
  var hasFocus = Controller.hasFocus,
      getIndex = Controller.getIndex;
  var items = [];
  var list;

  function mount() {
    init();
    on([EVENT_UPDATED, EVENT_REFRESH], init);
    on([EVENT_MOVE, EVENT_SCROLLED], update);
  }

  function init() {
    destroy();

    if (options.pagination && Slides.isEnough()) {
      createPagination();
      emit(EVENT_PAGINATION_MOUNTED, {
        list: list,
        items: items
      }, getAt(Splide2.index));
      update();
    }
  }

  function destroy() {
    if (list) {
      remove(list);
      items.forEach(function (item) {
        unbind(item.button, "click");
      });
      empty(items);
      list = null;
    }
  }

  function createPagination() {
    var length = Splide2.length;
    var classes = options.classes,
        i18n = options.i18n,
        perPage = options.perPage;
    var parent = options.pagination === "slider" && Elements.slider || Elements.root;
    var max = hasFocus() ? length : ceil(length / perPage);
    list = create("ul", classes.pagination, parent);

    for (var i = 0; i < max; i++) {
      var li = create("li", null, list);
      var button = create("button", {
        class: classes.page,
        type: "button"
      }, li);
      var controls = Slides.getIn(i).map(function (Slide) {
        return Slide.slide.id;
      });
      var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
      bind(button, "click", onClick.bind(null, i));
      setAttribute(button, ARIA_CONTROLS, controls.join(" "));
      setAttribute(button, ARIA_LABEL, format(text, i + 1));
      items.push({
        li: li,
        button: button,
        page: i
      });
    }
  }

  function onClick(page) {
    Controller.go(">".concat(page), true, function () {
      var Slide = Slides.getAt(Controller.toIndex(page));
      Slide && focus(Slide.slide);
    });
  }

  function getAt(index) {
    return items[Controller.toPage(index)];
  }

  function update() {
    var prev = getAt(getIndex(true));
    var curr = getAt(getIndex());

    if (prev) {
      removeClass(prev.button, CLASS_ACTIVE);
      removeAttribute(prev.button, ARIA_CURRENT);
    }

    if (curr) {
      addClass(curr.button, CLASS_ACTIVE);
      setAttribute(curr.button, ARIA_CURRENT, true);
    }

    emit(EVENT_PAGINATION_UPDATED, {
      list: list,
      items: items
    }, prev, curr);
  }

  return {
    items: items,
    mount: mount,
    destroy: destroy,
    getAt: getAt
  };
}

var TRIGGER_KEYS = [" ", "Enter", "Spacebar"];

function Sync(Splide2, Components2, options) {
  var list = Components2.Elements.list;
  var events = [];

  function mount() {
    Splide2.splides.forEach(function (target) {
      !target.isParent && sync(target.splide);
    });

    if (options.isNavigation) {
      navigate();
    }
  }

  function destroy() {
    removeAttribute(list, ALL_ATTRIBUTES);
    events.forEach(function (event) {
      event.destroy();
    });
    empty(events);
  }

  function remount() {
    destroy();
    mount();
  }

  function sync(splide) {
    [Splide2, splide].forEach(function (instance) {
      var event = EventInterface(instance);
      var target = instance === Splide2 ? splide : Splide2;
      event.on(EVENT_MOVE, function (index, prev, dest) {
        target.go(target.is(LOOP) ? dest : index);
      });
      events.push(event);
    });
  }

  function navigate() {
    var event = EventInterface(Splide2);
    var on = event.on;
    on(EVENT_CLICK, onClick);
    on(EVENT_SLIDE_KEYDOWN, onKeydown);
    on([EVENT_MOUNTED, EVENT_UPDATED], update);
    setAttribute(list, ROLE, "menu");
    events.push(event);
    event.emit(EVENT_NAVIGATION_MOUNTED, Splide2.splides);
  }

  function update() {
    setAttribute(list, ARIA_ORIENTATION, options.direction !== TTB ? "horizontal" : null);
  }

  function onClick(Slide) {
    Splide2.go(Slide.index);
  }

  function onKeydown(Slide, e) {
    if (includes(TRIGGER_KEYS, e.key)) {
      onClick(Slide);
      prevent(e);
    }
  }

  return {
    mount: mount,
    destroy: destroy,
    remount: remount
  };
}

function Wheel(Splide2, Components2, options) {
  var _EventInterface16 = EventInterface(Splide2),
      bind = _EventInterface16.bind;

  function mount() {
    if (options.wheel) {
      bind(Components2.Elements.track, "wheel", onWheel, {
        passive: false,
        capture: true
      });
    }
  }

  function onWheel(e) {
    var deltaY = e.deltaY;

    if (deltaY) {
      Splide2.go(deltaY < 0 ? "<" : ">");
      prevent(e);
    }
  }

  return {
    mount: mount
  };
}

var ComponentConstructors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Options: Options,
  Direction: Direction,
  Elements: Elements,
  Slides: Slides,
  Layout: Layout,
  Clones: Clones,
  Move: Move,
  Controller: Controller,
  Arrows: Arrows,
  Autoplay: Autoplay,
  Cover: Cover,
  Scroll: Scroll,
  Drag: Drag,
  Keyboard: Keyboard,
  LazyLoad: LazyLoad,
  Pagination: Pagination,
  Sync: Sync,
  Wheel: Wheel
});
var I18N = {
  prev: "Previous slide",
  next: "Next slide",
  first: "Go to first slide",
  last: "Go to last slide",
  slideX: "Go to slide %s",
  pageX: "Go to page %s",
  play: "Start autoplay",
  pause: "Pause autoplay"
};
var DEFAULTS = {
  type: "slide",
  speed: 400,
  waitForTransition: true,
  perPage: 1,
  arrows: true,
  pagination: true,
  interval: 5e3,
  pauseOnHover: true,
  pauseOnFocus: true,
  resetProgress: true,
  easing: "cubic-bezier(0.25, 1, 0.5, 1)",
  drag: true,
  direction: "ltr",
  slideFocus: true,
  trimSpace: true,
  focusableNodes: "a, button, textarea, input, select, iframe",
  classes: CLASSES,
  i18n: I18N
};

function Fade(Splide2, Components2, options) {
  var _EventInterface17 = EventInterface(Splide2),
      on = _EventInterface17.on;

  function mount() {
    on([EVENT_MOUNTED, EVENT_REFRESH], function () {
      nextTick(function () {
        Components2.Slides.style("transition", "opacity ".concat(options.speed, "ms ").concat(options.easing));
      });
    });
  }

  function start(index, done) {
    var track = Components2.Elements.track;
    style(track, "height", unit(rect(track).height));
    nextTick(function () {
      done();
      style(track, "height", "");
    });
  }

  return {
    mount: mount,
    start: start,
    cancel: noop
  };
}

function Slide(Splide2, Components2, options) {
  var _EventInterface18 = EventInterface(Splide2),
      bind = _EventInterface18.bind;

  var Move = Components2.Move,
      Controller = Components2.Controller;
  var list = Components2.Elements.list;
  var endCallback;

  function mount() {
    bind(list, "transitionend", function (e) {
      if (e.target === list && endCallback) {
        cancel();
        endCallback();
      }
    });
  }

  function start(index, done) {
    var destination = Move.toPosition(index, true);
    var position = Move.getPosition();
    var speed = getSpeed(index);

    if (abs(destination - position) >= 1 && speed >= 1) {
      apply("transform ".concat(speed, "ms ").concat(options.easing));
      Move.translate(destination, true);
      endCallback = done;
    } else {
      Move.jump(index);
      done();
    }
  }

  function cancel() {
    apply("");
  }

  function getSpeed(index) {
    var rewindSpeed = options.rewindSpeed;

    if (Splide2.is(SLIDE) && rewindSpeed) {
      var prev = Controller.getIndex(true);
      var end = Controller.getEnd();

      if (prev === 0 && index >= end || prev >= end && index === 0) {
        return rewindSpeed;
      }
    }

    return options.speed;
  }

  function apply(transition) {
    style(list, "transition", transition);
  }

  return {
    mount: mount,
    start: start,
    cancel: cancel
  };
}

var _Splide = /*#__PURE__*/function () {
  function _Splide(target, options) {
    _classCallCheck(this, _Splide);

    this.event = EventBus();
    this.Components = {};
    this.state = State(CREATED);
    this.splides = [];
    this._options = {};
    this._Extensions = {};
    var root = isString(target) ? query(document, target) : target;
    assert(root, "".concat(root, " is invalid."));
    this.root = root;
    merge(DEFAULTS, _Splide.defaults);
    merge(merge(this._options, DEFAULTS), options || {});
  }

  _createClass(_Splide, [{
    key: "mount",
    value: function mount(Extensions, Transition) {
      var _this3 = this;

      var state = this.state,
          Components2 = this.Components;
      assert(state.is([CREATED, DESTROYED]), "Already mounted!");
      state.set(CREATED);
      this._Components = Components2;
      this._Transition = Transition || this._Transition || (this.is(FADE) ? Fade : Slide);
      this._Extensions = Extensions || this._Extensions;
      var Constructors = assign({}, ComponentConstructors, this._Extensions, {
        Transition: this._Transition
      });
      forOwn(Constructors, function (Component, key) {
        var component = Component(_this3, Components2, _this3._options);
        Components2[key] = component;
        component.setup && component.setup();
      });
      forOwn(Components2, function (component) {
        component.mount && component.mount();
      });
      this.emit(EVENT_MOUNTED);
      addClass(this.root, CLASS_INITIALIZED);
      state.set(IDLE);
      this.emit(EVENT_READY);
      return this;
    }
  }, {
    key: "sync",
    value: function sync(splide) {
      this.splides.push({
        splide: splide
      });
      splide.splides.push({
        splide: this,
        isParent: true
      });

      if (this.state.is(IDLE)) {
        this._Components.Sync.remount();

        splide.Components.Sync.remount();
      }

      return this;
    }
  }, {
    key: "go",
    value: function go(control) {
      this._Components.Controller.go(control);

      return this;
    }
  }, {
    key: "on",
    value: function on(events, callback) {
      this.event.on(events, callback, null, DEFAULT_USER_EVENT_PRIORITY);
      return this;
    }
  }, {
    key: "off",
    value: function off(events) {
      this.event.off(events);
      return this;
    }
  }, {
    key: "emit",
    value: function emit(event) {
      var _this$event;

      (_this$event = this.event).emit.apply(_this$event, [event].concat(_toConsumableArray(slice(arguments, 1))));

      return this;
    }
  }, {
    key: "add",
    value: function add(slides, index) {
      this._Components.Slides.add(slides, index);

      return this;
    }
  }, {
    key: "remove",
    value: function remove(matcher) {
      this._Components.Slides.remove(matcher);

      return this;
    }
  }, {
    key: "is",
    value: function is(type) {
      return this._options.type === type;
    }
  }, {
    key: "refresh",
    value: function refresh() {
      this.emit(EVENT_REFRESH);
      return this;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var completely = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var event = this.event,
          state = this.state;

      if (state.is(CREATED)) {
        event.on(EVENT_READY, this.destroy.bind(this, completely), this);
      } else {
        forOwn(this._Components, function (component) {
          component.destroy && component.destroy(completely);
        }, true);
        event.emit(EVENT_DESTROY);
        event.destroy();
        completely && empty(this.splides);
        state.set(DESTROYED);
      }

      return this;
    }
  }, {
    key: "options",
    get: function get() {
      return this._options;
    },
    set: function set(options) {
      var _options = this._options;
      merge(_options, options);

      if (!this.state.is(CREATED)) {
        this.emit(EVENT_UPDATED, _options);
      }
    }
  }, {
    key: "length",
    get: function get() {
      return this._Components.Slides.getLength(true);
    }
  }, {
    key: "index",
    get: function get() {
      return this._Components.Controller.getIndex();
    }
  }]);

  return _Splide;
}();

var Splide = _Splide;
Splide.defaults = {};
Splide.STATES = STATES;
var CLASS_RENDERED = "is-rendered";
var RENDERER_DEFAULT_CONFIG = {
  listTag: "ul",
  slideTag: "li"
};

var Style = /*#__PURE__*/function () {
  function Style(id, options) {
    _classCallCheck(this, Style);

    this.styles = {};
    this.id = id;
    this.options = options;
  }

  _createClass(Style, [{
    key: "rule",
    value: function rule(selector, prop, value, breakpoint) {
      breakpoint = breakpoint || "default";
      var selectors = this.styles[breakpoint] = this.styles[breakpoint] || {};
      var styles = selectors[selector] = selectors[selector] || {};
      styles[prop] = value;
    }
  }, {
    key: "build",
    value: function build() {
      var _this4 = this;

      var css = "";

      if (this.styles.default) {
        css += this.buildSelectors(this.styles.default);
      }

      Object.keys(this.styles).sort(function (n, m) {
        return _this4.options.mediaQuery === "min" ? +n - +m : +m - +n;
      }).forEach(function (breakpoint) {
        if (breakpoint !== "default") {
          css += "@media screen and (max-width: ".concat(breakpoint, "px) {");
          css += _this4.buildSelectors(_this4.styles[breakpoint]);
          css += "}";
        }
      });
      return css;
    }
  }, {
    key: "buildSelectors",
    value: function buildSelectors(selectors) {
      var _this5 = this;

      var css = "";
      forOwn(selectors, function (styles, selector) {
        selector = "#".concat(_this5.id, " ").concat(selector).trim();
        css += "".concat(selector, " {");
        forOwn(styles, function (value, prop) {
          if (value || value === 0) {
            css += "".concat(prop, ": ").concat(value, ";");
          }
        });
        css += "}";
      });
      return css;
    }
  }]);

  return Style;
}();

var SplideRenderer = /*#__PURE__*/function () {
  function SplideRenderer(contents, options, config, defaults) {
    _classCallCheck(this, SplideRenderer);

    this.slides = [];
    this.options = {};
    this.breakpoints = [];
    merge(DEFAULTS, defaults || {});
    merge(merge(this.options, DEFAULTS), options || {});
    this.contents = contents;
    this.config = assign({}, RENDERER_DEFAULT_CONFIG, config || {});
    this.id = this.config.id || uniqueId("splide");
    this.Style = new Style(this.id, this.options);
    this.Direction = Direction(null, null, this.options);
    assert(this.contents.length, "Provide at least 1 content.");
    this.init();
  }

  _createClass(SplideRenderer, [{
    key: "init",
    value: function init() {
      this.parseBreakpoints();
      this.initSlides();
      this.registerRootStyles();
      this.registerTrackStyles();
      this.registerSlideStyles();
      this.registerListStyles();
    }
  }, {
    key: "initSlides",
    value: function initSlides() {
      var _this6 = this;

      push(this.slides, this.contents.map(function (content, index) {
        content = isString(content) ? {
          html: content
        } : content;
        content.styles = content.styles || {};
        content.attrs = content.attrs || {};

        _this6.cover(content);

        var classes = "".concat(_this6.options.classes.slide, " ").concat(index === 0 ? CLASS_ACTIVE : "");
        assign(content.attrs, {
          class: "".concat(classes, " ").concat(content.attrs.class || "").trim(),
          style: _this6.buildStyles(content.styles)
        });
        return content;
      }));

      if (this.isLoop()) {
        this.generateClones(this.slides);
      }
    }
  }, {
    key: "registerRootStyles",
    value: function registerRootStyles() {
      var _this7 = this;

      this.breakpoints.forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            width = _ref4[0],
            options = _ref4[1];

        _this7.Style.rule(" ", "max-width", unit(options.width), width);
      });
    }
  }, {
    key: "registerTrackStyles",
    value: function registerTrackStyles() {
      var _this8 = this;

      var Style2 = this.Style;
      var selector = ".".concat(CLASS_TRACK);
      this.breakpoints.forEach(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            width = _ref6[0],
            options = _ref6[1];

        Style2.rule(selector, _this8.resolve("paddingLeft"), _this8.cssPadding(options, false), width);
        Style2.rule(selector, _this8.resolve("paddingRight"), _this8.cssPadding(options, true), width);
        Style2.rule(selector, "height", _this8.cssTrackHeight(options), width);
      });
    }
  }, {
    key: "registerListStyles",
    value: function registerListStyles() {
      var _this9 = this;

      var Style2 = this.Style;
      var selector = ".".concat(CLASS_LIST);
      this.breakpoints.forEach(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
            width = _ref8[0],
            options = _ref8[1];

        Style2.rule(selector, "transform", _this9.buildTranslate(options), width);

        if (!_this9.cssSlideHeight(options)) {
          Style2.rule(selector, "aspect-ratio", _this9.cssAspectRatio(options), width);
        }
      });
    }
  }, {
    key: "registerSlideStyles",
    value: function registerSlideStyles() {
      var _this10 = this;

      var Style2 = this.Style;
      var selector = ".".concat(CLASS_SLIDE);
      this.breakpoints.forEach(function (_ref9) {
        var _ref10 = _slicedToArray(_ref9, 2),
            width = _ref10[0],
            options = _ref10[1];

        Style2.rule(selector, "width", _this10.cssSlideWidth(options), width);
        Style2.rule(selector, "height", _this10.cssSlideHeight(options) || "100%", width);
        Style2.rule(selector, _this10.resolve("marginRight"), unit(options.gap) || "0px", width);
        Style2.rule("".concat(selector, " > img"), "display", options.cover ? "none" : "inline", width);
      });
    }
  }, {
    key: "buildTranslate",
    value: function buildTranslate(options) {
      var _this$Direction = this.Direction,
          resolve = _this$Direction.resolve,
          orient = _this$Direction.orient;
      var values = [];
      values.push(this.cssOffsetClones(options));
      values.push(this.cssOffsetGaps(options));

      if (this.isCenter(options)) {
        values.push(this.buildCssValue(orient(-50), "%"));
        values.push.apply(values, _toConsumableArray(this.cssOffsetCenter(options)));
      }

      return values.filter(Boolean).map(function (value) {
        return "translate".concat(resolve("X"), "(").concat(value, ")");
      }).join(" ");
    }
  }, {
    key: "cssOffsetClones",
    value: function cssOffsetClones(options) {
      var _this$Direction2 = this.Direction,
          resolve = _this$Direction2.resolve,
          orient = _this$Direction2.orient;
      var cloneCount = this.getCloneCount();

      if (this.isFixedWidth(options)) {
        var _this$parseCssValue = this.parseCssValue(options[resolve("fixedWidth")]),
            value = _this$parseCssValue.value,
            unit2 = _this$parseCssValue.unit;

        return this.buildCssValue(orient(value) * cloneCount, unit2);
      }

      var percent = 100 * cloneCount / options.perPage;
      return "".concat(orient(percent), "%");
    }
  }, {
    key: "cssOffsetCenter",
    value: function cssOffsetCenter(options) {
      var _this$Direction3 = this.Direction,
          resolve = _this$Direction3.resolve,
          orient = _this$Direction3.orient;

      if (this.isFixedWidth(options)) {
        var _this$parseCssValue2 = this.parseCssValue(options[resolve("fixedWidth")]),
            value = _this$parseCssValue2.value,
            unit2 = _this$parseCssValue2.unit;

        return [this.buildCssValue(orient(value / 2), unit2)];
      }

      var values = [];
      var perPage = options.perPage,
          gap = options.gap;
      values.push("".concat(orient(50 / perPage), "%"));

      if (gap) {
        var _this$parseCssValue3 = this.parseCssValue(gap),
            _value = _this$parseCssValue3.value,
            _unit = _this$parseCssValue3.unit;

        var gapOffset = (_value / perPage - _value) / 2;
        values.push(this.buildCssValue(orient(gapOffset), _unit));
      }

      return values;
    }
  }, {
    key: "cssOffsetGaps",
    value: function cssOffsetGaps(options) {
      var cloneCount = this.getCloneCount();

      if (cloneCount && options.gap) {
        var orient = this.Direction.orient;

        var _this$parseCssValue4 = this.parseCssValue(options.gap),
            value = _this$parseCssValue4.value,
            unit2 = _this$parseCssValue4.unit;

        if (this.isFixedWidth(options)) {
          return this.buildCssValue(orient(value * cloneCount), unit2);
        }

        var perPage = options.perPage;
        var gaps = cloneCount / perPage;
        return this.buildCssValue(orient(gaps * value), unit2);
      }

      return "";
    }
  }, {
    key: "resolve",
    value: function resolve(prop) {
      return camelToKebab(this.Direction.resolve(prop));
    }
  }, {
    key: "cssPadding",
    value: function cssPadding(options, right) {
      var padding = options.padding;
      var prop = this.Direction.resolve(right ? "right" : "left", true);
      return padding && unit(padding[prop] || (isObject(padding) ? 0 : padding)) || "0px";
    }
  }, {
    key: "cssTrackHeight",
    value: function cssTrackHeight(options) {
      var height = "";

      if (this.isVertical()) {
        height = this.cssHeight(options);
        assert(height, '"height" is missing.');
        height = "calc(".concat(height, " - ").concat(this.cssPadding(options, false), " - ").concat(this.cssPadding(options, true), ")");
      }

      return height;
    }
  }, {
    key: "cssHeight",
    value: function cssHeight(options) {
      return unit(options.height);
    }
  }, {
    key: "cssSlideWidth",
    value: function cssSlideWidth(options) {
      return options.autoWidth ? "" : unit(options.fixedWidth) || (this.isVertical() ? "" : this.cssSlideSize(options));
    }
  }, {
    key: "cssSlideHeight",
    value: function cssSlideHeight(options) {
      return unit(options.fixedHeight) || (this.isVertical() ? options.autoHeight ? "" : this.cssSlideSize(options) : this.cssHeight(options));
    }
  }, {
    key: "cssSlideSize",
    value: function cssSlideSize(options) {
      var gap = unit(options.gap);
      return "calc((100%".concat(gap && " + ".concat(gap), ")/").concat(options.perPage || 1).concat(gap && " - ".concat(gap), ")");
    }
  }, {
    key: "cssAspectRatio",
    value: function cssAspectRatio(options) {
      var heightRatio = options.heightRatio;
      return heightRatio ? "".concat(1 / heightRatio) : "";
    }
  }, {
    key: "buildCssValue",
    value: function buildCssValue(value, unit2) {
      return "".concat(value).concat(unit2);
    }
  }, {
    key: "parseCssValue",
    value: function parseCssValue(value) {
      if (isString(value)) {
        var number = parseFloat(value) || 0;
        var unit2 = value.replace(/\d*(\.\d*)?/, "") || "px";
        return {
          value: number,
          unit: unit2
        };
      }

      return {
        value: value,
        unit: "px"
      };
    }
  }, {
    key: "parseBreakpoints",
    value: function parseBreakpoints() {
      var _this11 = this;

      var breakpoints = this.options.breakpoints;
      this.breakpoints.push(["default", this.options]);

      if (breakpoints) {
        forOwn(breakpoints, function (options, width) {
          _this11.breakpoints.push([width, merge(merge({}, _this11.options), options)]);
        });
      }
    }
  }, {
    key: "isFixedWidth",
    value: function isFixedWidth(options) {
      return !!options[this.Direction.resolve("fixedWidth")];
    }
  }, {
    key: "isLoop",
    value: function isLoop() {
      return this.options.type === LOOP;
    }
  }, {
    key: "isCenter",
    value: function isCenter(options) {
      if (options.focus === "center") {
        if (this.isLoop()) {
          return true;
        }

        if (this.options.type === SLIDE) {
          return !this.options.trimSpace;
        }
      }

      return false;
    }
  }, {
    key: "isVertical",
    value: function isVertical() {
      return this.options.direction === TTB;
    }
  }, {
    key: "buildClasses",
    value: function buildClasses() {
      var options = this.options;
      return [CLASS_ROOT, "".concat(CLASS_ROOT, "--").concat(options.type), "".concat(CLASS_ROOT, "--").concat(options.direction), options.drag && "".concat(CLASS_ROOT, "--draggable"), options.isNavigation && "".concat(CLASS_ROOT, "--nav"), CLASS_ACTIVE, !this.config.hidden && CLASS_RENDERED].filter(Boolean).join(" ");
    }
  }, {
    key: "buildAttrs",
    value: function buildAttrs(attrs) {
      var attr = "";
      forOwn(attrs, function (value, key) {
        attr += value ? " ".concat(camelToKebab(key), "=\"").concat(value, "\"") : "";
      });
      return attr.trim();
    }
  }, {
    key: "buildStyles",
    value: function buildStyles(styles) {
      var style = "";
      forOwn(styles, function (value, key) {
        style += " ".concat(camelToKebab(key), ":").concat(value, ";");
      });
      return style.trim();
    }
  }, {
    key: "renderSlides",
    value: function renderSlides() {
      var _this12 = this;

      var tag = this.config.slideTag;
      return this.slides.map(function (content) {
        return "<".concat(tag, " ").concat(_this12.buildAttrs(content.attrs), ">").concat(content.html || "", "</").concat(tag, ">");
      }).join("");
    }
  }, {
    key: "cover",
    value: function cover(content) {
      var styles = content.styles,
          _content$html = content.html,
          html = _content$html === void 0 ? "" : _content$html;

      if (this.options.cover && !this.options.lazyLoad) {
        var src = html.match(/<img.*?src\s*=\s*(['"])(.+?)\1.*?>/);

        if (src && src[2]) {
          styles.background = "center/cover no-repeat url('".concat(src[2], "')");
        }
      }
    }
  }, {
    key: "generateClones",
    value: function generateClones(contents) {
      var classes = this.options.classes;
      var count = this.getCloneCount();
      var slides = contents.slice();

      while (slides.length < count) {
        push(slides, slides);
      }

      push(slides.slice(-count).reverse(), slides.slice(0, count)).forEach(function (content, index) {
        var attrs = assign({}, content.attrs, {
          class: "".concat(content.attrs.class, " ").concat(classes.clone)
        });
        var clone = assign({}, content, {
          attrs: attrs
        });
        index < count ? contents.unshift(clone) : contents.push(clone);
      });
    }
  }, {
    key: "getCloneCount",
    value: function getCloneCount() {
      if (this.isLoop()) {
        var options = this.options;

        if (options.clones) {
          return options.clones;
        }

        var perPage = max.apply(void 0, _toConsumableArray(this.breakpoints.map(function (_ref11) {
          var _ref12 = _slicedToArray(_ref11, 2),
              options2 = _ref12[1];

          return options2.perPage;
        })));
        return perPage * ((options.flickMaxPages || 1) + 1);
      }

      return 0;
    }
  }, {
    key: "renderArrows",
    value: function renderArrows() {
      var html = "";
      html += "<div class=\"".concat(this.options.classes.arrows, "\">");
      html += this.renderArrow(true);
      html += this.renderArrow(false);
      html += "</div>";
      return html;
    }
  }, {
    key: "renderArrow",
    value: function renderArrow(prev) {
      var _this$options = this.options,
          classes = _this$options.classes,
          i18n = _this$options.i18n;
      var attrs = {
        class: "".concat(classes.arrow, " ").concat(prev ? classes.prev : classes.next),
        type: "button",
        ariaLabel: prev ? i18n.prev : i18n.next
      };
      return "<button ".concat(this.buildAttrs(attrs), "><svg xmlns=\"").concat(XML_NAME_SPACE, "\" viewBox=\"0 0 ").concat(SIZE, " ").concat(SIZE, "\" width=\"").concat(SIZE, "\" height=\"").concat(SIZE, "\"><path d=\"").concat(this.options.arrowPath || PATH, "\" /></svg></button>");
    }
  }, {
    key: "html",
    value: function html() {
      var _this$config = this.config,
          rootClass = _this$config.rootClass,
          listTag = _this$config.listTag,
          arrows = _this$config.arrows,
          beforeTrack = _this$config.beforeTrack,
          afterTrack = _this$config.afterTrack,
          slider = _this$config.slider,
          beforeSlider = _this$config.beforeSlider,
          afterSlider = _this$config.afterSlider;
      var html = "";
      html += "<div id=\"".concat(this.id, "\" class=\"").concat(this.buildClasses(), " ").concat(rootClass || "", "\">");
      html += "<style>".concat(this.Style.build(), "</style>");

      if (slider) {
        html += beforeSlider || "";
        html += "<div class=\"splide__slider\">";
      }

      html += beforeTrack || "";

      if (arrows) {
        html += this.renderArrows();
      }

      html += "<div class=\"splide__track\">";
      html += "<".concat(listTag, " class=\"splide__list\">");
      html += this.renderSlides();
      html += "</".concat(listTag, ">");
      html += "</div>";
      html += afterTrack || "";

      if (slider) {
        html += "</div>";
        html += afterSlider || "";
      }

      html += "</div>";
      return html;
    }
  }], [{
    key: "clean",
    value: function clean(splide) {
      var _EventInterface19 = EventInterface(splide),
          on = _EventInterface19.on;

      var root = splide.root;
      var clones = queryAll(root, ".".concat(CLASS_CLONE));
      on(EVENT_MOUNTED, function () {
        remove(child(root, "style"));
      });
      remove(clones);
    }
  }]);

  return SplideRenderer;
}();

export { CLASSES, CLASS_ACTIVE, CLASS_ARROW, CLASS_ARROWS, CLASS_ARROW_NEXT, CLASS_ARROW_PREV, CLASS_AUTOPLAY, CLASS_CLONE, CLASS_CONTAINER, CLASS_INITIALIZED, CLASS_LIST, CLASS_LOADING, CLASS_NEXT, CLASS_PAGINATION, CLASS_PAGINATION_PAGE, CLASS_PAUSE, CLASS_PLAY, CLASS_PREV, CLASS_PROGRESS, CLASS_PROGRESS_BAR, CLASS_ROOT, CLASS_SLIDE, CLASS_SLIDER, CLASS_SPINNER, CLASS_TRACK, CLASS_VISIBLE, EVENT_ACTIVE, EVENT_ARROWS_MOUNTED, EVENT_ARROWS_UPDATED, EVENT_AUTOPLAY_PAUSE, EVENT_AUTOPLAY_PLAY, EVENT_AUTOPLAY_PLAYING, EVENT_CLICK, EVENT_DESTROY, EVENT_DRAG, EVENT_DRAGGED, EVENT_DRAGGING, EVENT_HIDDEN, EVENT_INACTIVE, EVENT_LAZYLOAD_LOADED, EVENT_MOUNTED, EVENT_MOVE, EVENT_MOVED, EVENT_NAVIGATION_MOUNTED, EVENT_PAGINATION_MOUNTED, EVENT_PAGINATION_UPDATED, EVENT_READY, EVENT_REFRESH, EVENT_REPOSITIONED, EVENT_RESIZE, EVENT_RESIZED, EVENT_SCROLL, EVENT_SCROLLED, EVENT_SLIDE_KEYDOWN, EVENT_UPDATED, EVENT_VISIBLE, EventBus, EventInterface, RequestInterval, STATUS_CLASSES, Splide, SplideRenderer, State, Throttle, Splide as default };